import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { cacheKeys } from '../config';
import { userClient } from '../client/userClient';

export type Params = {
  id: string;
  authenticate?: boolean;
};

type Options = {
  enabled: boolean
  retry: boolean
};

const defaultOptions: Partial<Options> = {
  enabled: true,
};

export const useUser = (params: Params, options: Partial<Options> = defaultOptions) => {
  const { data: { data: user } = {}, status, error } = useQuery(
    [cacheKeys.getUser, params.id],
    () => userClient.getUser({ id: params.id }, params.authenticate),
    {
      ...options,
      // Force react-query to infer the error type
      onError: (err: AxiosError) => err,
    },
  );

  return {
    status,
    error,
    user,
  };
};
